import feedback from "../Assets/feedback_Mesa de trabajo 1.png"
import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import { useUser } from "../Context";
import { useState } from "react";
import Loading from "./Loading";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../Firebase";

const StyledRating = styled(Rating)(({ theme }) => ({
    '& .MuiRating-iconEmpty .MuiSvgIcon-root': {
        color: theme.palette.action.disabled,
    },
}));

const customIcons = {
    1: {
        icon: <SentimentVeryDissatisfiedIcon color="error" fontSize="large" />,
        label: 'Very Dissatisfied',
    },
    2: {
        icon: <SentimentDissatisfiedIcon color="error" fontSize="large" />,
        label: 'Dissatisfied',
    },
    3: {
        icon: <SentimentSatisfiedIcon color="warning" fontSize="large" />,
        label: 'Neutral',
    },
    4: {
        icon: <SentimentSatisfiedAltIcon color="success" fontSize="large" />,
        label: 'Satisfied',
    },
    5: {
        icon: <SentimentVerySatisfiedIcon color="success" fontSize="large" />,
        label: 'Very Satisfied',
    },
};

function IconContainer(props) {
    const { value, ...other } = props;
    return <span {...other}>{customIcons[value].icon}</span>;
}

IconContainer.propTypes = {
    value: PropTypes.number.isRequired,
};

export default function Feedback() {
    const { user, loading, setLoading } = useUser()
    const [email, setEmail] = useState()
    const [rating, setRating] = useState()
    const [feedbacks, setFeedbacks] = useState("")

    useEffect(() => {
        if (user) {
            setEmail(user.email);
        }
    }, [user])

    const handleRatingChange = (event, newValue) => {
        setRating(newValue);
    };

    async function handleFeedback() {
        try {
            setLoading(true);
            if (!rating) {
                toast.warn("Please give a rating.");
            }
            if (!email) {
                toast.warn("Please enter email.");
            }
            const feedbackDoc = await addDoc(collection(db, 'feedback'), {
                email,
                rating,
                feedbacks
            })

            if (feedbackDoc.id) {
                toast.success("Feeback submitted.")
            }
            else {
                toast.error("Error in submitting feedback")
            }
            setFeedbacks("")
            setRating()
            setLoading(false)
        }
        catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            {loading ? <Loading /> :
                <div className="flex w-screen items-center px-24 py-6 gap-12">
                    <img className="w-5/12" src={feedback} alt="feedback" />
                    <div className="flex flex-col gap-6">
                        <h1 className="text-[3rem] antialiased font-semibold text-transparent bg-gradient-to-tr from-sky-500 to-indigo-500 bg-clip-text">
                            We're eager to improve. <br />Share your thoughts with us!
                        </h1>
                        <div className="flex border p-4 px-6 min-h-48 rounded-3xl shadow-md gap-3 flex-col">
                            <StyledRating
                                name="highlight-selected-only"
                                value={rating} // Set the value prop to control the rating
                                onChange={handleRatingChange}
                                IconContainerComponent={IconContainer}
                                getLabelText={(value) => customIcons[value].label}
                                highlightSelectedOnly
                            />
                            {!user &&
                                // <div className="flex gap-3 text-blue-500 items-center text-lg">
                                //     Email:
                                <input type="email" placeholder="johndoe@gmail.com" className="border py-2 px-3 rounded-xl text-lg outline-none hover:shadow-md transition-all duration-200 focus:shadow-md text-blue-600" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                                // </div>
                            }
                            <textarea placeholder="your feedback" className="border py-1.5 px-3 rounded-xl text-lg min-h-32 outline-none hover:shadow-md transition-all duration-200 focus:shadow-md text-blue-600" value={feedbacks} onChange={(e) => { setFeedbacks(e.target.value) }}>

                            </textarea>
                            <button onClick={() => { handleFeedback() }} className="shadow-sm w-fit rounded-xl px-4 py-2 flex-shrink-0 justify-center gap-3 flex items-center border hover:shadow-lg text-gray-700 text-lg transition-all duration-400 hover:bg-sky-500 hover:text-white" >Submit</button>
                        </div>
                    </div>
                </div>
            }
        </>

    )
}